import React from "react";
import "./card.css";
import CardItem from "./CardItem";

const CardList = (props) => {

  const {dev_id_with_name} = props

  return (
    <>
      <div className="container">

      <div className="row">
      
      {
        dev_id_with_name.map((dev, i) => <CardItem devInfo={dev} key={i} /> )
      }
     

      </div>

      </div>
    </>
  )
}

export default CardList
